import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const subcategoryApiService = createApi({
  reducerPath: 'subcategoryApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/subcategory/'),
  endpoints: (builder) => ({
    getSubcategories: builder.query({
      query: (args) => {
        let { id, currentPage, itemsPerPage, search, active, category } = args

        if (id) {
          return `get/${id}`
        }

        return `get?page=${currentPage}&rowsPerPage=${itemsPerPage}${(search && search !== '') ? `&search=${search}` : ``}${(active && active !== '') ? `&active=${active}` : ``}${(category && category !== null && category !== "") ? `&category=${category}` : ``}`
      },
      keepUnusedDataFor: 0
    }),
    updateSubcategory: builder.mutation({
      query: (args) => {

        let { id, payload } = args
        let url = `update/${id}`

        if (!id) {
          url = 'update'
        }

        return ({
          url,
          method: 'PUT',
          body: payload
        })

      }
    })
  })
})

export const {
  useGetSubcategoriesQuery,
  useUpdateSubcategoryMutation
} = subcategoryApiService